import {Brick, ErrorFlow, registerBrick} from 'olympe';

export default class ConvertUsersFromMDInGraphAPIFormat extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} mdResult
     * @param {function(string)} setGraphAPIFormat
     * @param {function(*)} setErrorFlow
     */
    update($, [mdResult], [setGraphAPIFormat, setErrorFlow]) {
        try {
            const parsedResult = JSON.parse(mdResult);
            setGraphAPIFormat(JSON.stringify({
                value: parsedResult.map((userInfo) => ({
                    givenName: userInfo.NameFirst,
                    surname: userInfo.NameLast,
                    onPremisesSamAccountName: userInfo.Bname,
                    mail: userInfo.EmailID,
                })),
            }));
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Impossible to parse result from MD ' + e, 1004));
        }
    }
}

registerBrick('019527ccedafa4c3d850', ConvertUsersFromMDInGraphAPIFormat);
